<section class="content">
    <div class="card" style="padding:30px" *ngIf="!show_grn_page">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                {{title}}
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-6 col-lg-3 col-md-3">
                <label style="font-size: 15px;">Enter Employee Code and Search <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                <input type="number" class="form-control" (keydown.enter)="serveEmployeeOrder()" id="booth_number"
                    style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;"
                    [(ngModel)]="selected_employee_code">
            </div>
            <div class="col-sm-6 col-lg-2 col-md-2" style="margin-left: 12px; margin-top: 4%;">
                <button mat-raised-button color="primary" (click)="serveEmployeeOrder()" class="button-class"
                    style="font-size: 20px; height: 40px;" [disabled]="selected_employee_code == null">Search</button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!is_data_available">
        <div class="col">
            <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
            </mat-progress-spinner>
        </div>
    </div>
    <span *ngIf="by_product_order_list.length != 0 && is_data_available && !show_grn_page">
        <mat-card *ngFor="let order of by_product_order_list; let order_index=index" style="margin-bottom: 2%">
            <div class="row">
                <div class="col"><label>{{order['business_code']}} - {{order['agent_name']}}</label></div>
                <div class="col"><label>Ordered On : {{order['ordered_date'] | date}} Via
                        {{order['ordered_via']}}</label></div>
                <div class="col"><label>Total Price : {{order['total_cost'] | currency: 'INR'}}</label></div>
                <div class="col">
                    <button mat-button (click)="generateBillCalled(order)"
                        style="background: green;border-radius: 10px; font-size: 23px; color: white;">Generate
                        Bill</button>
                </div>
                <div class="col">
                    <button mat-button (click)="returnGRNCalled(order)"
                        style="background: green;border-radius: 10px; font-size: 23px; color: white; margin-left: 12%;">Return
                        GRN</button>

                </div>
            </div><br>
            <table class="table table-bordered table-hovered">
                <thead>
                    <tr>
                        <th>S. No</th>
                        <th>Product Short Name</th>
                        <th>Count</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody *ngFor="let product of order['product_list']; let product_index=index">
                    <tr>
                        <td>{{product_index + 1}}</td>
                        <td>{{product['by_product_name']}}</td>
                        <td>{{product['count']}}</td>
                        <td>{{product['cost']}}</td>
                    </tr>
                </tbody>
            </table>
        </mat-card>
    </span>
    <div class="row" *ngIf="show_grn_page">
        <div class="col-sm-2 col-lg-2" (click)="enableProductList()">
            <i class="material-icons" style="margin-left: 2%; font-size:46px;cursor: pointer;">arrow_back</i>
        </div>
        <div class="col-sm-6 col-lg-6">
            <p class="text-center" style="font-size: 30px;">New GRN</p>
        </div>
        <div class="col-sm-4 col-lg-4"></div>
    </div>
    <mat-card *ngIf="show_grn_page">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-8">
                <div class="row" style="font-weight: 600;margin-top: 15px;padding: 11px;">
                    <div class="col-4">Product</div>
                    <div class="col-1">Ordered Qty</div>
                    <div class="col-2">Expiry Date</div>
                    <div class="col-2">Return Qty</div>
                    <div class="col-2" style="text-align: right;">Billing Qty</div>
                </div>
                <div class="row" *ngFor="let product of selected_product_list; let product_index=index"
                    style="padding: 10px;">
                    <div class="col-4">
                        {{product['by_product_name']}}
                    </div>
                    <div class="col-1">
                        {{product['count']}}
                    </div>
                    <div class="col-2">
                        {{product['expiry_date'] | date}}
                    </div>
                    <div class="col-2">
                        <input (keyup)="productQuantityChanged(product_index)" type="number"
                            [(ngModel)]="selected_product_list[product_index]['return_qty']"
                            style="border: 1px solid;text-indent: 11px;" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                    </div>
                    <div class="col-2" style="text-align: right;">
                        <p>{{product['billing_qty']}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col" style="text-align: center;">
                        <button mat-button (click)="confirmClicked()" style="background: green;color: white;">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>

</section>